import React, { Fragment } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Row } from 'reactstrap';
import { Formik, Form, ErrorMessage, Field } from 'formik';
import { AddHolidaySchema } from '../../../../helpers/schemas';
import { Messages } from '../../../layout/Messages/Messages';
import * as Notifications from '../../../../config/notifications';
import DatePicker from "react-datepicker";
import { FieldMessages } from "../../../layout/Messages/FieldMessages";
import { createAppointmentHoliday } from '../../../../api/appointmentHolidays/appointmentHolidays';
import moment from 'moment';
import { CustomField } from '../../../../components/pages/profile/CustomField';

function CreateAppointmentHolidayForm(props) {
  const intl = useIntl();
  const getErrorClass = (formikProps, fieldName) => {
    return formikProps && formikProps.touched && formikProps.touched[fieldName] ? formikProps.errors && formikProps.errors[fieldName] !== undefined ? 'custom-is-invalid' : '' : '';
  }

  return (
    <Formik
    initialValues={{ dayAsTimestamp: ''}}
    validationSchema={ AddHolidaySchema }
    enableReinitialize={ true }
    onSubmit={ (values, {setSubmitting, resetForm}) => {
      const { dayAsTimestamp, description } = values;

      let payload = {
        notificationId: Notifications.NOTIFICATION_ADD_APPOINTMENT_HOLIDAY,
        data: {
          day_as_timestamp: moment(dayAsTimestamp).format("YYYY-MM-DD"),
          description: description,
        }
      }

      createAppointmentHoliday(payload).then(() => { props.actionRefreshTable() });
      resetForm({
        day_as_timestamp: '',
        description: '',
      });
      setSubmitting(false);
    }}
    >
      {formikProps => (
        <Fragment>
          <Messages
            notificationId={ Notifications.NOTIFICATION_ADD_APPOINTMENT_HOLIDAY }
          >
          </Messages>
          <Form>
            <Row>
              <label className='form-control-label d-block'>
                <FormattedMessage id="fields.appointments.holiday_date"/>
              </label>
              <DatePicker
                name="dayAsTimestamp"
                placeholderText={ intl.formatMessage({ id: "fields.appointments.holiday_date" }) }
                className={ "form-control " + getErrorClass(formikProps, 'dayAsTimestamp') }
                selected={ formikProps.values.dayAsTimestamp ? new Date(formikProps.values.dayAsTimestamp) : '' }
                minDate={ Date.now() }
                showDisabledMonthNavigation
                yearDropdownItemNumber={ 50 }
                scrollableYearDropdown
                showYearDropdown
                dateFormat="dd-MM-yyyy"
                onChange={
                  dayAsTimestamp => {
                    if (dayAsTimestamp) {
                      formikProps.setFieldValue('dayAsTimestamp', new Date(dayAsTimestamp));
                      return;
                    }
                  
                    formikProps.setFieldValue('dayAsTimestamp', new Date(Date.now()));
                  }
                }
                errorClass={ getErrorClass(formikProps, 'dayAsTimestamp') }
              />
              <FieldMessages
                color="danger"
                formikProps={ formikProps }
                class="small-field-error"
                showDismiss={ false }
                name="dayAsTimestamp"
                addMargin={ true }
                notificationId={ Notifications.NOTIFICATION_ADD_APPOINTMENT_HOLIDAY }
              >
                <ErrorMessage
                  name="dayAsTimestamp"
                  component="div"
                  data-testid="errors-dayAsTimestamp"
                />
              </FieldMessages>

              <CustomField
                type="text"
                label="fields.appointments.description"
                fieldName="description"
                name="description"
                onChange={ (event) => {
                  formikProps.setFieldValue("description", event.target.value);
                } }
                value={ formikProps.values.description }
                getErrorClass={ getErrorClass(formikProps, "description") }
                className="w-100 mt-2"
                errorClass={ getErrorClass(formikProps, 'description') }
              />

              <FieldMessages
                color="danger"
                class="small-field-error"
                formikProps={ formikProps }
                showDismiss={ false }
                name="description"
                addMargin={ true }
                notificationId={ Notifications.NOTIFICATION_ADD_APPOINTMENT_HOLIDAY } 
              >
                <ErrorMessage
                  name="description"
                  component="div"
                  data-testid="errors-description"
                  className="no-input-margin"
                />
              </FieldMessages>
              
            </Row>
              
            <Row>
                <FormattedMessage id="components.pages.appointments.holidays_settings.add_holiday">
                  {
                    valueBtn => <Field className="my-4 btn btn-primary mx-auto" type="submit" value={valueBtn}/>
                  }
                </FormattedMessage>
            </Row>

          </Form>
        </Fragment>
      )}
    </Formik>
  );
}

export { CreateAppointmentHolidayForm };
